<template>
  <div
    @click="logDynamicData"
  >
    <component
        :is="props.product.enableRedirection || props.landingPageUrl ? NuxtLinkWithLocale : 'div'"
        v-bind="linkAttrs"
        :id="props.id || `product-banner-${random_id}`"
        :class="twMerge(
          'ts-banner h-full relative font-gilroy rounded-lg overflow-hidden max-w-max bg-primary',
          (props.product?.enableRedirection || props.landingPageUrl) && 'inline-block'
      )"
        :style="root_styles"
    >
      <div ref="bannerHomeDealsAndOfferRefV2" class="w-full h-full flex flex-col p-4 pt-14 relative max-w-[320px] md:max-w-[300px] min-w-[320px] md:min-w-[300px]">

        <div v-if="props.image && props.image.src" class="w-full relative flex justify-center mb-4">
          <div
              v-if="product_data && product_data.prices && product_data.prices.formatted"
              :class="twMerge(
            'absolute top-0 text-center text-idle-white mt-3 px-2 flex flex-col',
            !rootStore.isIncVat && 'flex-col-reverse'
        )">
            <div :class="twMerge(rootStore.isIncVat ? 'text-sm' : 'text-xs')">{{useTranslation("nowAt","Nu bij")}} <span :class="twMerge(rootStore.isIncVat && 'text-base font-bold')">{{ product_data.prices.formatted.gross }}</span></div>
            <div :class="twMerge(rootStore.isIncVat ? 'text-xs' : 'text-sm')">Excl. {{useTranslation("vat","btw")}} <span :class="twMerge(!rootStore.isIncVat && 'text-base font-bold')">{{ product_data.prices.formatted.net }}</span></div>
          </div>
          <TsImage class="mt-auto"
                   :src="props.image.src"
                   :alt="props.image.alt || 'deals'"
                   width="147"
                   loading="lazy"
          />
        </div>

        <div class="mt-auto">
          <div
              :class="twMerge('text-[14px] text-idle-white leading-tight')"
              :style="sub_title_styles"
              v-html="props.subTitle && props.subTitle.text">
          </div>

          <div
              :class="twMerge('text-[20px] font-bold text-idle-white leading-tight mb-3')"
              :style="title_styles"
              v-html="(props.product && props.product.enableTitle && product_data && product_data?.full_name) ? product_data?.full_name : props.title?.text">
          </div>

          <div
              :class="twMerge('text-[14px] text-white leading-none')"
              :style="description_styles"
              v-html="(props.product && props.product.enableDescription && product_data && product_data?.description
) ? product_data?.description
 : props.description?.text">
          </div>
        </div>
      </div>
    </component>
  </div>
</template>

<script setup lang="ts">
import {useTranslation} from "~/composables/useTranslation";

import { twMerge } from "tailwind-merge";

const rootStore = useRootStore();
type Props = {
  id?: string;
  dataTestid?: string;
  landingPageUrl?: string;
  product?: object;
  image?: object;
  alt?:string;
  subTitle?: object;
  title?: object;
  description?: object;
  backgroundColor?: object;
}

const bannerHomeDealsAndOfferRefV2 = useTemplateRef('bannerHomeDealsAndOfferRefV2');

let observer: IntersectionObserver;

const observeElement = (element: HTMLElement) => {
  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      fetchProduct()
    }
  })
  observer.observe(element)
};

const fetchProduct = async () => {
  // Replace with your actual fetch request
  if(props.product?.id) {
    const {useProductStore} = await import('~/stores/product.store');
    const productStore = useProductStore();
    product_data.value = await productStore.getProductById(product_id.value);
    bannerView(product_data?.value, "banner home deals and offer V2");
  }
  if (observer && bannerHomeDealsAndOfferRefV2.value) {
    observer.unobserve(bannerHomeDealsAndOfferRefV2.value)
  }
}

const props = withDefaults(defineProps<Props>(), {
  dataTestid: 'highlights',
  image: () => ({
    src: '/banners/desktop/images/banner-deals-and-offers-1.png'
  }),
  subTitle: () => ({
    text: 'Tool Up for Savings'
  }),
  title: () => ({
    text: 'Grab Your Gear Now!'
  }),
  description: () => ({
    text: 'Triton JOF001 router 1,010W 6-12mm'
  })
})

const random_id = ref('');
const product_id = computed(() => props.product?.id);
const product_data = ref(null);

const NuxtLinkWithLocale = resolveComponent('NuxtLinkWithLocale');
const linkAttrs = computed(() => ({
  ...(props.landingPageUrl && {to: props.landingPageUrl}),
  ...(props.product?.enableRedirection && {to: getProductSlug(product_data.value?.slug, product_data.value?.code)}),
}))

const sub_title_styles = computed(() => ({
  ...(props.subTitle?.color && {color: props.subTitle?.color}),
  ...(props.subTitle?.fontSize && {fontSize: props.subTitle?.fontSize})
}))

const title_styles = computed(() => ({
  ...(props.title?.color && {color: props.title?.color}),
  ...(props.title?.fontSize && {fontSize: props.title?.fontSize})
}))

const description_styles = computed(() => ({
  ...(props.description?.color && {color: props.description?.color}),
  ...(props.description?.fontSize && {fontSize: props.description?.fontSize}),
}))

const root_styles = computed(() => ({
  ...(props.backgroundColor?.color && {backgroundColor: props.backgroundColor.color }),
  ...(props.backgroundColor?.custom && {backgroundColor: props.backgroundColor.custom }),
}))

onMounted(async () => {
  random_id.value = useRandomUUID();
  if (bannerHomeDealsAndOfferRefV2.value) {
    observeElement(bannerHomeDealsAndOfferRefV2.value)
  }
});

const stopBannerProductCodeWatcher = watch(product_id, async () => {
  await fetchProduct();
})
// GTM Log FOR banner click
const logDynamicData = () => {
  bannerClick(product_data?.value, "banner home deals and offer V2");
};

onUnmounted(() => {
  if (observer && bannerHomeDealsAndOfferRefV2.value) {
    observer.unobserve(bannerHomeDealsAndOfferRefV2.value)
  }
  stopBannerProductCodeWatcher();
})
</script>
